import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import ProcessManager from '../../../Common/Managers/ProcessManager';

import { GenericErrorScreen } from 'com-gyf-webcore-userinterfacecomponents';
import MessagePopup from '../../../Packages/SharedComponents/Com.Gyf.WebCore.MessagePopup';

import Title from './Title.jsx';
import Header from './Header.jsx';
import Table from './Table.jsx';
let tipoOperacion = null;
class AsignarPerfilAUsuario extends Component {
    constructor(props) {
        super(props);

        this.saveSessionStorage = this.saveSessionStorage.bind(this);    
    }

    componentDidMount() {
        const id = this.props.match.params.id;
        tipoOperacion = id.charAt(id.length - 1);
        this.props.getScreenData(id, this.props.currentScope);
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.data.messageHidden) {
            setTimeout(() => {
                this.props.hidePopUp();
            }, 7000);
        }
    }

    componentWillUnmount() {
        this.props.resetStateAsignPerfUsr();
    }

    saveSessionStorage(){
        sessionStorage.setItem("usuariosSeleccionados", JSON.stringify(this.props.data.usuariosSeleccionados))
        sessionStorage.setItem("idPerfil", this.props.match.params.id)
    }

    render() {
        let component = null;
        let spinner = null;

        if (this.props.data.redirect == true)
            return <Redirect to={ProcessManager.GetNextStep("AsignarPerfilAUsuario", "ROUTE_TO_PERFILES_Y_PERMISOS")} push />

        if (this.props.data.isFetching == true)
            spinner = <div className="loading">Loading&#8230;</div>

        if (this.props.data.isFetching == true)
            return spinner;

        if (this.props.data.functions != undefined && this.props.data.functions.length > 0) {

            let functions = this.props.data.functions;       
            let usuariosParaMostrar;     
            
            if(tipoOperacion == 1)
                usuariosParaMostrar = this.props.data.usuariosFiltrados.filter(x => x.Bloqueado_Inactividad != true && x.Bloqueado != true && x.Activo == true);
            else
                usuariosParaMostrar = this.props.data.usuariosFiltrados;
            

            if (functions.Consulta == true) {
                if (this.props.data.usuarios == undefined)
                    return spinner;

                component = (
                    <div className="container-fluid concierge">
                        {spinner}

                        <Title titulo1={(tipoOperacion == 1)? 'Asignar el perfil ': 'Des-Asignar el perfil '}
                            titulo2={this.props.data.title2}
                            titulo3={' a los usuarios: '}/>

                        {/*POP UP*/}
                        <div className="bottom-separator-xxs">
                            <MessagePopup isHidden={this.props.data.messageHidden}
                                message={this.props.data.message}
                                classMessage={this.props.data.messageClass} />
                        </div>

                        <Header
                            functions={this.props.data.functions}
                            usuarios={this.props.data.usuarios}
                            searchUser={this.props.searchUser}
                            usuariosFiltrados={usuariosParaMostrar}
                            setActivosCheckbox={this.props.setActivosCheckbox}
                            setBloqueadosCheckbox={this.props.setBloqueadosCheckbox}
                            setEliminadosCheckbox={this.props.setEliminadosCheckbox}
                            setMotivoBloqueo={this.props.setMotivoBloqueo}
                            setUserState={this.props.setUserState}
                            asignarPerfil={this.props.asignarPerfil}
                            tipoOperacion={tipoOperacion}
                            desasignarPerfil={this.props.desasignarPerfil}
                        />

                        <Table
                            functions={this.props.data.functions}
                            currentUser={this.props.data.currentUser}
                            usuarios={this.props.data.usuarios}
                            usuariosFiltrados={usuariosParaMostrar}
                            columnIndex={this.props.data.columnIndex}
                            column={this.props.data.column}
                            orderColumn={this.props.orderColumn}
                            setAllCheckbox={this.props.setAllCheckbox}
                            allCheckboxFilter={this.props.data.allCheckboxFilter}
                            setCheckbox={this.props.setCheckbox}
                            setUserState={this.props.setUserState}
                            tipoOperacion={tipoOperacion}
                            idPerfil={this.props.match.params.id}
                            saveSessionStorage={this.saveSessionStorage}
                        />
                    </div>
                );
            } else {
                let values = {
                    message: "Disculpe, no tiene permisos para acceder a esta pantalla.",
                    linkMessage: "Volver a mi pagina de inicio"
                };

                component = (
                    <div>
                        {spinner}
                        <GenericErrorScreen data={values} />
                    </div>);
            }

            return (component);
        } else {
            return null;
        }
    }
}

export default AsignarPerfilAUsuario;